import {Circle} from "react-konva";
import {useCombatants} from "@/encounter/combatants/CombatantHooks.ts";
import {useDungeon} from "@/encounter/dungeon/DungeonHooks.ts";
import {useEncounterLights} from "@/encounter/lights/EncounterLightHooks.ts";
import {useTableTopSelection} from "@/tabletop/selection/TableTopSelectionHooks.ts";
import {effectiveLights} from "@/tabletop/visibility/LightGeometry.ts";
import {CharacterSizes} from "@/characters/model/CharacterSizes.ts";
import {lightMarkerLayout} from "./LightMarkerLayout.ts";
import {isLightLocked, lightLockKey} from "./LightLockState.ts";

export default function EncounterLightLayer({selectedId, toggledLightLocks, onSelect, onMove}: {
    selectedId?: string; onSelect: (id: string) => void;
    toggledLightLocks: ReadonlySet<string>;
    onMove: (id: string, position: {x: number; y: number}) => void;
}) {
    const {dungeon, dungeonSettings} = useDungeon();
    const {state} = useEncounterLights();
    const {combatants} = useCombatants();
    const {clearSelection} = useTableTopSelection();
    const level = dungeon.levels.find(item => item.id === dungeonSettings.levelId);
    if (!level) return null;
    return <>{effectiveLights(level.geometry, level.id, state, combatants).map(light => {
        const source = combatants.find(combatant => combatant.id === light.combatantId);
        const attached = Boolean(source);
        const {position, radius} = lightMarkerLayout(light.origin,
            source ? CharacterSizes.get(source.character.size) : undefined);
        return <Circle key={light.id} x={position.x} y={position.y} radius={radius}
            fill={light.enabled ? light.color : "#555"} stroke={selectedId === light.id ? "#fff" : "#222"}
            strokeWidth={2} opacity={0.9}
            draggable={!attached && !isLightLocked(light.source,
                lightLockKey(level.id, light.id), toggledLightLocks)}
            onDragStart={() => {clearSelection(); onSelect(light.id);}}
            onDragEnd={event => onMove(light.id, {x: event.target.x(), y: event.target.y()})}
            onClick={event => {event.cancelBubble = true; clearSelection(); onSelect(light.id);}}
            onTap={event => {event.cancelBubble = true; clearSelection(); onSelect(light.id);}}/>;
    })}</>;
}
